import {useHistory} from 'react-router-dom';
import ContextMenu from '../../../../shared-components/custom-features/contextmenu/ContextMenu';
import React from 'react';
import {useEntityActions} from '../../../../ducks/entityactions';

function RowActions({entityId, rowPeek, entityType, t}) {
    const history = useHistory();

    const entityActions = useEntityActions(entityType.dataTypeId, entityId);

    if (entityActions.loading) {
        return (
            <ContextMenu.Section>
                <ContextMenu.TextItem label={t('generalShared.loading')} />
            </ContextMenu.Section>
        );
    }

    let entityLink = entityActions.entityLink;

    return (
        <ContextMenu.Section>
            {rowPeek && entityLink && entityLink.includes('detail') && (
                <ContextMenu.Item icon="ZoomIn" label={t('generalShared.peek')} onClick={rowPeek} />
            )}
            {entityLink && (
                <ContextMenu.Item
                    icon="Forward"
                    label={t('generalShared.openInThisWindow')}
                    onClick={() => history.push(entityLink)}
                />
            )}
            {entityLink && (
                <ContextMenu.Item
                    icon="OpenInNew"
                    label={t('generalShared.openInNewWindow')}
                    onClick={() => window.open('#' + entityLink, '_blank')}
                />
            )}
        </ContextMenu.Section>
    );
}

export {RowActions};
